<template>
    <div style="display: flex; flex-direction: column;">
        <div style="">
            <MercenaryHeader :title="'메시지 정보'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        </div>
        <div style="margin-top: 40px; flex: 1;">
            <div style="text-align: center;">
                <ProfileImage style="height: 100px;" :imagePath="single_opponent_member.image_path"></ProfileImage>
                <div style="display: flex; align-items: center; gap: 4px; justify-content: center; margin-top: 4px;">
                    <div style="font-weight: 700; font-size: 14px; line-height: 16px;">{{ single_opponent_member.nic_name }}</div>
                    <template v-if="single_opponent_member.is_coach == 1 ">
                        <img v-if="single_opponent_member.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                        <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                    </template>
                    <span v-else style="font-weight: 700; font-size: 14px; color: var(--color-main);">{{ single_opponent_member.position }}</span>
                </div>
                <!-- <div v-if="single_opponent_member.is_coach == 1" style="font-size: 12px; font-weight: 500; color: #808080; margin-top: 4px; line-height: 20px;">프리랜서 코치</div> -->
            </div>
            <div style="margin-top: 40px; padding: 0 12px;">
                <div style="display: flex; align-items: center; gap: 12px; border-bottom: 1px solid #ebebeb; padding-bottom: 20px;">
                    <div>
                        <img style="width: 24px;" :src="require('@/assets/img/chat_message.png')" alt="">
                    </div>
                    <div v-if="single_opponent_member.is_coach == 1 && isExistRequest" style="font-weight: 700; font-size: 14px; line-height: 24px;">다이렉트 메시지</div>
                    <div v-else style="font-weight: 700; font-size: 14px; line-height: 24px;">1:1 메시지</div>
                </div>
                <div v-if="single_opponent_member.is_coach == 1 && isExistRequest" style="padding-top: 20px;">
                    <div @click="showRequest(false)" style="display: flex; align-items: center; gap: 12px;">
                        <div>
                            <img style="width: 24px;" :src="require('@/assets/img/chat_team.png')" alt="">
                        </div>
                        <div style="font-weight: 700; flex: 1; font-size: 14px;">
                            <div style="line-height: 24px;">입단 요청서</div>
                            <div style="line-height: 24px; color: #606060; font-weight: 500;">내 요청서 보기</div>
                        </div>
                        <div>
                            <img style="width: 10px;" :src="require('@/assets/img/counsel_arrow.png')" alt="">
                        </div>
                    </div>
                    <div @click="showTeam" style="display: flex; align-items: center; gap: 12px; margin-top: 20px;">
                        <div>
                            <img style="width: 24px;" :src="require('@/assets/img/chat_request.png')" alt="">
                        </div>
                        <div style="font-weight: 700; flex: 1; font-size: 14px;">
                            <div style="line-height: 24px;">소속 팀</div>
                            <div style="line-height: 24px; color: #606060; font-weight: 500;">{{ single_opponent_member.team_name }}</div>
                        </div>
                        <div>
                            <img style="width: 10px;" :src="require('@/assets/img/counsel_arrow.png')" alt="">
                        </div>
                    </div>
                </div>
                <div v-else style="padding-top: 20px;">
                    <div @click="showProfile" style="display: flex; align-items: center; gap: 12px;">
                        <div>
                            <img style="width: 24px;" :src="require('@/assets/img/chat_profile.png')" alt="">
                        </div>
                        <div style="font-weight: 700; flex: 1; font-size: 14px;">
                            <div style="line-height: 24px;">프로필 보기</div>
                        </div>
                        <div>
                            <img style="width: 10px;" :src="require('@/assets/img/counsel_arrow.png')" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div style="margin-top: 20px; font-weight: 700; font-size: 14px; margin-bottom: 8px; padding-left: 12px;">채팅 상대</div>
            <div style="padding: 0 12px;">
                <div style="padding: 12px; border-radius: 12px; background-color: #f5f5f5; font-weight: 500; line-height: 24px;">{{ nic_name }}</div>
            </div> -->

        </div>
        <div style="height: 150px; padding: 0 12px;">
            <div @click="alramOff(); $Util.sendEventClick('멤버톡_알림설정')" style="display: flex; gap: 10px; align-items: center; justify-content: center;" class="common_box">
                <img v-if="is_alarm_disable_copy == 0" style="width: 14px;" :src="require('@/assets/img/alarm_off_black.png')" alt="">
                <img v-else style="width: 14px;" :src="require('@/assets/img/alram_on.png')" alt="">
                <div v-if="is_alarm_disable_copy == 0" style="font-size: 14px; font-weight: 500; color: #210f03; line-height: 20px;">알림 끄기</div>
                <div v-else style="font-size: 14px; font-weight: 500; color: var(--color-main); line-height: 20px;">알림 켜기</div>
            </div>
            <div style="margin-bottom: 40px;" v-if="!$Util.isAdmin(single_opponent_member.member_idx)">
                <CommonBottomBtn :btnClickEvent="setIsOpenPopupFrame" :changeWidth="'100%'" :btnName="'나가기'"></CommonBottomBtn>
            </div>
        </div>
        <CommonPopupFrame :isOpen="isOpenPopupFrame" :changeHeight="232" :changeHeightUnit="'px'">
            <div style="padding: 16px 20px;">
                <div @click="closePopupFrame" style="font-weight: 700; line-height: 24px;">닫기</div>
                <div style="font-weight: 700; font-size: 20px; line-height: 24px; text-align: center; margin-top: 32px;">채팅을 완전히 나갈까요?</div>
                <div @click="outPersonalChat(); $Util.sendEventClick('채팅_나가기')" style="margin-top: 40px; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">확인</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import MercenaryHeader from "@/components/common/MercenaryHeader"
import ProfileImage from "@/components/common/ProfileImage"
import CommonBottomBtn from "@/components/common/CommonBottomBtn"
import ResponseCode from "@/ResponseCode"
import { FORM_MODE, MAIN_TYPE, TEAM_TYPE } from "@/Constants"
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'

export default {
    name: 'PersonalChatSetting',
    components: { MercenaryHeader, ProfileImage, CommonBottomBtn, CommonPopupFrame },
    props: {
        closeAction: {
            type: Function,
            default: () => { }
        },
        chat_idx: {
            type: [String, Number],
            default: -1
        },
        is_alarm_disable: {
            type: [String, Number],
            default: -1
        },
        setAlarmDisable: {
            type: Function,
            default: () => { }
        },
        nic_name: {
            type: String,
            default: ''
        },
        single_opponent_member: {
            type: Object,
            default: () => { }
        },
    },
    data() {
        return {
            TEAM_TYPE: TEAM_TYPE,
            is_alarm_disable_copy: -1,
            isOpenPopupFrame: false,
            isExistRequest: false
        }
    },
    methods: {
        setIsOpenPopupFrame() {
            this.isOpenPopupFrame = true
        },
        showTeam() {
            this.$GlobalStore.addModal('SoccerTeamDetail', { isModalBackTransparent: true, teamIdx: this.single_opponent_member.team_idx })
        },
        closePopupFrame() {
            this.isOpenPopupFrame = false
        },
        async showRequest(isCheck = false) {
            const parameters = {};
            parameters.member_idx = this.single_opponent_member.member_idx;
            const res = await this.$Axios.get('/api/soccerhow/target/last/reporting', { params: parameters });
            if (res.data.soccerhow) {
                if (isCheck) {
                    this.isExistRequest = true
                    return
                }
                this.$GlobalStore.addModal('TrainingRequestDetail', { likeFromDetail: this.likeFromDetail, main_type: MAIN_TYPE.SOCCER_LEARN, isModalBackTransparent: true, soccerhowIdx: res.data.soccerhow.idx })
            } else {
                if (isCheck) {
                    this.isExistRequest = false
                    return
                }
                this.$GlobalStore.showAlert('등록된 요청서가 없습니다.');
            }
        },
        showProfile() {
            this.$Util.showProfile(this.single_opponent_member.member_idx, this.single_opponent_member.member_type)
        },
        async outPersonalChat() {
            const formData = new FormData()
            formData.append('chat_idx', this.chat_idx)

            const res = await this.$Axios.post('/api/chat/getout', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.closeModalAll()
                this.closeAction(FORM_MODE.DELETE)
            }
        },
        async alramOff() {
            const formData = new FormData()
            formData.append('chat_idx', this.chat_idx)
            formData.append('is_alarm_disable', this.is_alarm_disable_copy == 1 ? 0 : 1)

            const res = await this.$Axios.post('/api/chat/setting', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                let isOff = this.is_alarm_disable_copy == 1 ? 0 : 1
                this.is_alarm_disable_copy = isOff
                this.setAlarmDisable(isOff)
            }
        }
    },
    created() {
        this.is_alarm_disable_copy = this.is_alarm_disable
        this.outPersonalChat = this.$Once(this.outPersonalChat)
        this.alramOff = this.$Once(this.alramOff)
        this.showRequest(true)
        console.log(this.single_opponent_member)
    }
}
</script>

<style scoped>
.common_box {
    background-color: #f5f5f5;
    padding: 12px;
    border-radius: 12px;
}
</style>
